<template>
  <div class="relative overflow-hidden rounded-full">
    <div
      class="absolute inset-y-0 left-0 flex w-20 items-center justify-center border-r border-background-fg/8 bg-background-fg/3"
    >
      Search
    </div>
    <input
      :value="modelValue"
      type="search"
      enterkeyhint="search"
      :class="[
        'block w-full rounded-full border border-background-fg/8 bg-background pl-24 text-base font-semibold focus:outline-none', // Font size set at >14px (text-base) so no zoom on mobile when focused
        'focus:border-primary focus:ring-primary',
      ]"
      @input="onInput"
    />
  </div>
</template>

<script setup lang="ts">
const modelValue = defineModel<string>({ required: true })

const onInput = (event: Event) => {
  const value_ = (event.target as HTMLInputElement)?.value
  modelValue.value = value_
}
</script>
